import Typo from '@/ui/typo/Typo';
import {
  Container,
  Wrapper,
  NameWrapper,
  DataWrapper,
  RankContainer,
  NameContainer,
  Data,
  Img,
} from './IndustryRankStyles';
import Plus from '@/ui/icon/plus/Plus';
import Score2 from '@/ui/caption/score2/Score2';
import pulseImg from '@/assets/pulse.svg';
import vectorImg from '@/assets/vector.svg';
import exposureImg from '@/assets/exposure.svg';

interface IndustryRankProps {
  type?: string;
  rank?: number;
  companyName?: string;
  score?: string;
  scoreChange?: number;
  onClick?: () => void;
  onAdd?: () => void;
  onCancel?: () => void;
  isSelected?: boolean;
}

const IndustryRank = ({
  type,
  rank,
  companyName,
  score,
  scoreChange,
  onClick,
  onAdd,
  onCancel,
  isSelected,
}: IndustryRankProps) => {
  return (
    <Container>
      <Wrapper onClick={onClick}>
        <NameContainer>
          <RankContainer>
            <div className="text-primary-500">{rank}</div>
          </RankContainer>
          <NameWrapper>
            <div className="text-sm text-text-400">{companyName}</div>
          </NameWrapper>
        </NameContainer>

        <div className="flex items-center justify-end gap-1 w-[95px]">
          <div className="mr-auto">
            {type === 'pulse' ? <Img src={pulseImg} alt="pulse" /> : null}
            {type === 'exposure' ? <Img src={exposureImg} alt="pulse" /> : null}
            {type === 'vector' ? <Img src={vectorImg} alt="pulse" /> : null}
          </div>
          <div className="text-sm text-text-300">{score}</div>
          <Score2 change={scoreChange} />
          <Plus onClick={isSelected ? onCancel : onAdd} isSelected={isSelected} />
        </div>
      </Wrapper>
    </Container>
  );
};

export default IndustryRank;
